import { Flip, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

let toastId = "EMR";

export function warn(message) {
  showToast(message, "warning");
}

export function info(message) {
  showToast(message, "info");
}

export function success(message) {
  showToast(message, "success", 1500);
}

export function error(message) {
  showToast(message, "error");
}

function showToast(message, type, autoCloseTime) {
  const options = {
    position: "top-center",
    toastId,
    autoClose: autoCloseTime || 9000,
    transition: Flip,
  };

  switch (type) {
    case "warning":
      options.type = "warning";
      break;
    case "info":
      options.type = "info";
      break;
    case "success":
      options.type = "success";
      break;
    case "error":
      options.type = "error";
      break;
    default:
      options.type = "default";
  }

  try {
    toast(message, options);
  } catch (e) {
    // Fallback if something goes wrong with the toast library
    console.error("Toast error:", e);
  }
}
